import { render, staticRenderFns } from "./PaymentRouteView.vue?vue&type=template&id=73ff556a"
import script from "./PaymentRouteView.vue?vue&type=script&lang=js"
export * from "./PaymentRouteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports